import ViewerType from "./DataType";
import TextContainer from "./TextContainer";

export default class HtmlContainer extends TextContainer {
	public getType(): ViewerType {
		return ViewerType.HTML;
	}
}